export interface IContamination {
  newOutputs: number[],
  oldOutputs: number[],
  outputsToCheck: number[],
  onContamination: (output: number) => any,
}
export function detectContamination({ newOutputs, oldOutputs, outputsToCheck, onContamination }: IContamination) {
  const changed: number[] = [];

  for (const key in oldOutputs) {
    if (newOutputs[key] !== oldOutputs[key] && Number(newOutputs[key]) === 1) {
      if (outputsToCheck.includes(Number(key)+1)) {
        changed.push(Number(key)+1);
      }
    }
  }

  if (changed.length) {
    onContamination(changed[0]);
  }

}
